import { render, staticRenderFns } from "./card-mobile-bind.vue?vue&type=template&id=316e04d6"
import script from "./card-mobile-bind.vue?vue&type=script&lang=js"
export * from "./card-mobile-bind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports